"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tag = _interopRequireDefault(require("../tag/tag"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProductMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProductMenu, _React$PureComponent);

  var _super = _createSuper(ProductMenu);

  function ProductMenu() {
    var _this;

    _classCallCheck(this, ProductMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "buildTag", function (item) {
      var tagProps = {
        theme: item.tag,
        customLabel: item.customTagProps ? item.customTagProps.customLabel : undefined,
        customTooltipText: item.customTagProps ? item.customTagProps.customTooltipText : undefined,
        customStyles: item.customTagProps ? item.customTagProps.customStyles : undefined
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ml-neg3"
      }, /*#__PURE__*/_react.default.createElement(_tag.default, _extends({}, tagProps, {
        small: true
      })));
    });

    return _this;
  }

  _createClass(ProductMenu, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dr-ui--product-menu"
      }, props.tag && this.buildTag(props), /*#__PURE__*/_react.default.createElement("a", {
        href: props.homePage,
        className: (0, _classnames.default)('txt-fancy txt-l block', {
          'color-white color-gray-light-on-hover': props.lightText,
          'color-blue-on-hover': !props.lightText
        })
      }, props.productName));
    }
  }]);

  return ProductMenu;
}(_react.default.PureComponent);

ProductMenu.propTypes = {
  productName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  tag: _propTypes.default.oneOf(['legacy', 'beta', 'fundamentals', 'new', 'custom']),

  /* Required if tag is set to `custom` */
  customTagProps: _propTypes.default.shape({
    customLabel: _propTypes.default.string.isRequired,
    customTooltipText: _propTypes.default.string.isRequired,
    customStyles: _propTypes.default.shape({
      background: _propTypes.default.string.isRequired,
      color: _propTypes.default.string.isRequired,
      borderColor: _propTypes.default.string.isRequired
    }).isRequired
  }),
  lightText: _propTypes.default.bool,
  homePage: _propTypes.default.string.isRequired
};
ProductMenu.defaultProps = {
  lightText: false
};
var _default = ProductMenu;
exports.default = _default;